import React from "react";
import LegalContent from "../../components/common/LegalContent";

export default function PrivacyPolicy() {
  return <LegalContent type="privacy" />;
}
